// 个人中心学习报告
import ajax from '@/utils/ajax';

const header = '/web';

// 学习报告基础信息
export const reqPersonalBasisInfo = () => ajax(`${header}/v1/learn-report/basis-info`);

// 学习报告服务信息
export const reqPersonalServiceInfo = () => ajax(`${header}/v1/learn-report/service-info`);

// 学习报告上周学习时长信息
export const reqPersonalWeekTime = () => ajax(`${header}/v1/learn-report/week-duration`);

// 学习报告各学科学习时长信息
export const reqPersonalSubjectInfo = () => ajax(`${header}/v1/learn-report/discipline-duration`);

// 查询是否有绑定学习报告的拉新活动
export const reqPersonalBindPullNew = () => ajax(`${header}/v1/pull-new/activity/bind/study-report`);
//用户历史周报
export const reqAnswerPage = (data) => ajax(`${header}/statistics/answer-question-statistics/page?pageNum=${data.pageNum}&pageSize=${data.pageSize}`);

//根据用户id和平台获取会员一周答题统计数
export const reqWeekAnswer = () => ajax(`${header}/statistics/answer-question-statistics/week`);

//周报详情
export const reqWeekDetail = (id) => ajax(`${header}/statistics/answer-question-statistics/detail/${id}`);
//获取用户会员中心信息
export const getUserMemberCenter = async () => await ajax(`${header}/v1/user-member/center/info`);
